import { useEffect, useRef } from 'react';

const useVersionControl = (
  pathname,
  autoCheck = false,
  defaultOptions = null
) => {
  const hasCheckedRef = useRef(false);

  const APP_SITE = process.env.REACT_APP_SITE || '';
  const metaJsonPath = APP_SITE ? `/${APP_SITE}/meta.json` : '/meta.json';

  const checkVersion = async ({
    type,
    infoSearch,
    flightSearchType = '',
    force = false,
  }) => {
    // console.error('[VersionControl] Iniciando checkVersion...');
    // console.error(`[VersionControl] PATHNAME: ${pathname}`);
    // console.error(`[VersionControl] meta.json path: ${metaJsonPath}`);
    // console.error(`[VersionControl] Force check: ${force}`);
    // console.error(
    //   `[VersionControl] Has checked before: ${hasCheckedRef.current}`
    // );

    const CURRENT_VERSION = window?.__APP_VERSION__ || '0.0.0';
    // console.error(
    //   `[VersionControl] Versión actual en window.__APP_VERSION__: ${CURRENT_VERSION}`
    // );

    if (hasCheckedRef.current && !force) {
      // console.error(
      //   '[VersionControl] Ya se chequeó la versión previamente y no es force, saliendo.'
      // );
      return;
    }

    hasCheckedRef.current = true;

    try {
      const response = await fetch(`${metaJsonPath}?ts=${Date.now()}`);
      // console.error(
      //   `[VersionControl] fetch realizado a: ${metaJsonPath}?ts=${Date.now()}`
      // );
      // console.error(`[VersionControl] Estado de respuesta: ${response.status}`);

      const contentType = response.headers.get('content-type');
      //  console.error(`[VersionControl] Content-Type de respuesta: ${contentType}`);

      if (!response.ok || !contentType?.includes('application/json')) {
        // console.warn(
        //   '[VersionControl] Respuesta inválida o content-type no es JSON, abortando check.'
        // );
        return;
      }

      const { version } = await response.json();
      //  console.error(`[VersionControl] Versión obtenida de meta.json: ${version}`);

      if (CURRENT_VERSION !== version) {
        //   console.error('[VersionControl] Las versiones NO coinciden.');

        const storedVersion = localStorage.getItem('app_version');
        // console.error(
        //   `[VersionControl] Versión almacenada en localStorage: ${storedVersion}`
        // );

        const key = `search-${type}`;

        if (storedVersion !== version || force) {
          if (type !== 'router') {
            const dataToStore = JSON.stringify({
              type,
              infoSearch,
              flightSearchType,
            });
            localStorage.setItem(key, dataToStore);
            //     console.error(
            //         `[VersionControl] Guardando búsqueda actual en localStorage con key: ${key}`
            //       );
          }

          //    console.error(
          //     '[VersionControl] Forzando recarga de la página con nueva versión...'
          //   );
          localStorage.setItem('app_version', version);
          window.location.replace(pathname || '/');
        } else {
          //     console.error(
          //       '[VersionControl] La versión almacenada es igual a la nueva, no se recarga.'
          //       );
        }
      } else {
        //     console.error(
        //        '[VersionControl] Las versiones coinciden, limpiando localStorage.'
        //      );
        [
          'search-assist',
          'search-hotel',
          'search-flights',
          'app_version',
        ].forEach(key => {
          localStorage.removeItem(key);
          //     console.error(`[VersionControl] localStorage eliminado: ${key}`);
        });
      }
    } catch (error) {
      //   console.error('[VersionControl] Error al chequear la versión:', error);
    }
  };

  useEffect(() => {
    if (autoCheck && defaultOptions) {
      // console.error(
      //   '[VersionControl] Auto-check habilitado, ejecutando checkVersion con opciones por defecto.'
      // );
      checkVersion(defaultOptions);
    }
  }, [autoCheck, defaultOptions, pathname]);

  return { checkVersion };
};

export default useVersionControl;
